function initializePeptique(root=document){
  root.querySelectorAll('[data-preview-cart]').forEach(button=>{
    if(button.dataset.initialized)return;
    button.dataset.initialized='true';
    button.addEventListener('click',()=>{const feedback=button.nextElementSibling;if(feedback)feedback.hidden=false;});
  });
  root.querySelectorAll('.pq').forEach(page=>{
    if(page.dataset.initialized)return;
    page.dataset.initialized='true';
    const storyImage=page.querySelector('[data-pq-story-image]');
    const storyTrigger=page.querySelector('[data-pq-story-trigger]');
    if(storyImage&&storyTrigger){
      const storyAside=storyImage.parentElement;
      const mobile=window.matchMedia('(max-width:760px)');
      const reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
      let frame=0;
      storyAside.classList.add('pq-story-stage');
      storyImage.classList.add('pq-story-pending');
      let state='quote',fadeTimer;
      const update=()=>{
        frame=0;
        const top=storyTrigger.getBoundingClientRect().top;
        // Separate thresholds prevent flickering near the reveal boundary.
        if(top>window.innerHeight*.65){
          if(state==='quote-out'||state==='ready'){
            clearTimeout(fadeTimer);
            state='quote';
            storyAside.classList.remove('pq-quote-leaving');
          }else if(state==='image'){
            state='image-out';
            storyImage.classList.remove('pq-story-visible');
            fadeTimer=setTimeout(()=>{
              state='quote';
              storyAside.classList.remove('pq-quote-leaving');
              update();
            },reduced.matches?0:1530);
          }
          return;
        }
        if(state==='image-out'){
          clearTimeout(fadeTimer);
          state='ready';
        }
        if(state==='quote'&&top<=window.innerHeight*.45){
          state='quote-out';
          storyAside.classList.add('pq-quote-leaving');
          fadeTimer=setTimeout(()=>{state='ready';update();},reduced.matches?0:330);
        }
        if(state==='ready'){
          state='image';
          storyImage.classList.add('pq-story-visible');
        }
      };
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
      const placeImage=()=>{
        if(mobile.matches)(page.querySelector('#pq-hollywood-chapter')||storyTrigger).after(storyImage);
        else storyAside.append(storyImage);
        update();
      };
      placeImage();
      mobile.addEventListener('change',placeImage);
      reduced.addEventListener('change',schedule);
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule);
      const cleanup=()=>{
        window.removeEventListener('scroll',schedule);
        window.removeEventListener('resize',schedule);
        mobile.removeEventListener('change',placeImage);
        reduced.removeEventListener('change',schedule);
        cancelAnimationFrame(frame);
        clearTimeout(fadeTimer);
      };
      page.closest('.shopify-section')?.addEventListener('shopify:section:unload',cleanup,{once:true});
    }
    const mobileBar=page.querySelector('.pq-mobile-bar');
    const buyBoxes=page.querySelector('#pq-buy-boxes');
    if(mobileBar&&buyBoxes){
      const observer=new IntersectionObserver(entries=>{
        const hidden=entries[0].isIntersecting;
        mobileBar.classList.toggle('pq-bar-hidden',hidden);
        mobileBar.inert=hidden;
      },{threshold:0});
      observer.observe(buyBoxes);
      const button=mobileBar.querySelector('a');
      const goToOffers=()=>buyBoxes.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
      button.addEventListener('click',event=>{event.preventDefault();goToOffers();});
      page.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
    }
    page.querySelectorAll('dialog').forEach(dialog=>{
    let opener;
    const triggers=dialog.dataset.pqPolicyUrl ? [...page.querySelectorAll('a[href]')].filter(link=>new URL(link.href,location.href).pathname===new URL(dialog.dataset.pqPolicyUrl,location.href).pathname) : dialog.id ? [...page.querySelectorAll('[data-pq-dialog], [data-pq-guarantee]')].filter(link=>link.dataset.pqDialog===dialog.id||(dialog.id==='pq-returns-policy'&&link.hasAttribute('data-pq-guarantee'))) : page.querySelectorAll('[data-pq-guarantee]');
    triggers.forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();opener=link;dialog.classList.toggle('pq-pointer-open',event.detail>0);dialog.showModal();document.documentElement.classList.add('pq-modal-open');
    }));
    if(dialog.id==='pq-contact'&&(dialog.querySelector('[data-pq-contact-result]')||location.hash==='#pq-contact')){dialog.showModal();document.documentElement.classList.add('pq-modal-open');}
    dialog.addEventListener('keydown',()=>dialog.classList.remove('pq-pointer-open'));
    dialog.querySelector('[data-pq-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{dialog.classList.remove('pq-pointer-open');if(!page.querySelector('dialog[open]'))document.documentElement.classList.remove('pq-modal-open');opener?.focus({preventScroll:true});});
    });
  });
}
initializePeptique();
document.addEventListener('shopify:section:load',event=>initializePeptique(event.target));
